import { Component, OnInit } from '@angular/core';

/**
 * 已弃用
 * @deprecated
 */
@Component({
  selector: 'app-expression-schema-info-grid',
  templateUrl: './expression-schema-info-grid.component.html',
  // styleUrls: ['./expression-schema-info-grid.component.css']
})
export class ExpressionSchemaInfoGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
